import { addToGlobalThisRet } from "@plugins";

const searchList = document.querySelector(".js-filter-colors-search-init");
const searchInput = document.querySelector(".js-filter-colors-search-input");

function filterColorsCollapsableInit() {
    const filterColors = document.querySelector(".js-filter-colors-collapsable-init");

    const toggleFilterBlocksView = () => {
        filterColors.classList.toggle("blocks-swapped");
    };

    const toggleFilterColors = (changer) => {
        const newText = changer.innerHTML === "Показать ещё" ? "Свернуть" : "Показать ещё";
        raplaceChangerText(changer, newText);
        toggleFilterBlocksView();
    };

    const raplaceChangerText = (changer, newText) => {
        if (changer.innerHTML !== newText) {
            changer.innerHTML = newText;
        }
    };

    if (filterColors) {
        const changer = filterColors.querySelector(".js-filter-colors-changer");

        if (changer) {
            changer.addEventListener("click", () => {
                toggleFilterColors(changer);
            });
        }
    }
}

function filterColorsSearchInit() {
    if (searchList) {
        const searchInputUpper = searchInput.value.toUpperCase();
        const searchItems = searchList.querySelectorAll(".js-filter-colors-block-item");

        searchItems.forEach((item) => {
            const searchItemText = item.querySelector(".switcher-item__label-text");
            if (searchItemText.innerHTML.toUpperCase().indexOf(searchInputUpper) > -1) {
                item.style.display = "";
            } else {
                item.style.display = "none";
            }
        });
    }
}

if (searchInput) {
    searchInput.addEventListener("keyup", filterColorsSearchInit);
}

window.addEventListener("load", filterColorsCollapsableInit(), filterColorsSearchInit());

addToGlobalThisRet(filterColorsSearchInit, "filterColorsSearchInit");
